import { isEmpty } from '../../lib/validator/helpers'

export default {
  /** EMPTY DEVICE */
  emptyDevice (index = this.currentDeviceIndex) {
    const newDevice = { ...this.deviceTemplate }

    if (!isEmpty(this.devices[index].pack_identifier)) {
      newDevice.chosenCategory = this.devices[index].chosenCategory
      newDevice.pack_identifier = this.devices[index].pack_identifier
    }

    this.$set(this.devices, index, newDevice)

    this.setDefaultBrandOnDeviceIfNeeded(index)
  },

  setDefaultBrandOnDeviceIfNeeded (index = null) {
    /* If there is only one brand in the list, set this brand to the device */
    const brands = this.data_device.brands
    if (brands.length === 1) {
      index === null
        ? this.lastDevice.brand = brands[0].name
        : this.devices[index].brand = brands[0].name
    }
  },

  /* Create new empty device */
  newDevice (addedManually = false) {
    /* Set the elements of the new device */
    this.$set(this.devices, this.devices.length, { ...this.deviceTemplate })

    /* SET INCIDENT DATE TO TODAY BY DEFAULT */
    if (this.productType === this.productTypes.OUT_WARRANTY) this.lastDevice.incidentDate = this.date.max

    this.setDefaultBrandOnDeviceIfNeeded()

    /* While there is fewer devices than the min required for this offer, create another one */
    /* At the end show the first device */
    /* If this is a manually added device => show the new device added */
    if (this.productType === this.productTypes.INSURANCE && this.devices.length < this.chosenOffer.min_devices) {
      this.newDevice()
    } else {
      this.currentDeviceIndex = addedManually ? this.devices.length - 1 : 0
      this.$nextTick(_ => {
        this.$refs['ref_step_device_' + this.currentDeviceIndex][0].$el.focus()
      })
    }
  },

  emptyDevices () {
    this.devices.forEach((device, index) => {
      this.emptyDevice(index)
    })
  },

  /* Modal delete devices */
  open_model_delete_devices () {
    /* Open model if there is at least one information filled */
    /* Else if empty, can delete without opening modal */
    if (this.is_devices_filled) {
      this.visibleModal = this.modalNames.deleteDevices
    } else this.deleteDevices()
  },

  deleteDevices () {
    this.currentDeviceIndex = 0
    this.devices = []
    this.newDevice()
  },

  /** DELETE DEVICE */
  /* Modal delete device */
  openModalDeleteDevice (index) {
    if (!this.devices_filled[index]) {
      return this.deleteDevice(index)
    }
    this.current_delete_device_index = index
    this.visibleModal = this.modalNames.deleteDevice
  },

  deleteDevice (index) {
    if (this.currentDeviceIndex !== 0) this.currentDeviceIndex--
    this.$delete(this.devices, index)
  },

  updateCategory (value, index) {
    this.devices[index].chosenCategory = value
  },

  /* KEY HANDLE DEVICES */
  keyupDevices (e) {
    if (e.key === 'Delete' && this.devices.length > 1) {
      this.openModalDeleteDevice(this.currentDeviceIndex)
    } else if (e.key === 'Enter' && this.canAddDevice) {
      this.newDevice(true)
    }
  }
}
